import React from "react";
import FooterComponent from "./../../Generic/Footer/FooterComponent";
import HeaderComponent from "./../../Generic/Header/HeaderComponent";
import SeoMeta from "./../../Generic/SEO/SeoMeta";
import ProductListing from "../Catalog/ProductListing";
import * as endpoint from "./../../../Service/endpoints";

function SearchComponent({ match }) {
  const query = match.params.query || "";

  return (
    <React.Fragment>
      <SeoMeta
        title={`${query} on Rent | Voorent`}
        description={`Rent ${query.toLowerCase()} online with flexible monthly plans, delivery and set-up from Voorent.`}
        canonical={`https://voorent.com/search/${encodeURIComponent(query)}`}
      />
      <HeaderComponent />
      <ProductListing
        mode="search"
        query={query}
        heading={`Results for “${query}”`}
        crumbs={[
          { label: "Home", to: endpoint.getPath("") },
          { label: "Search", to: null },
          { label: query, to: `/search/${encodeURIComponent(query)}` },
        ]}
      />
      <FooterComponent />
    </React.Fragment>
  );
}

export default SearchComponent;
